import refs from '../helpers/refs'

class CVideoGallery {
  constructor (el) {
    this.$el = el
    this.$refs = refs(this.$el)

    this.init()
  }

  init () {
    this.$refs.navigationButton.forEach((navigationButton) => {
      navigationButton.addEventListener('click', (e) => {
        // Handle iOS Safari's buggy click event behavior
        e.preventDefault()
        e.stopPropagation()

        const currentCategorySlug = e.currentTarget.getAttribute(
          'data-c-video-gallery-category-slug'
        )

        this.$el.querySelectorAll('.is-active').forEach((element) => {
          element.classList.remove('is-active')
        })
        this.$el
          .querySelectorAll(
            `[data-c-video-gallery-category-slug="${currentCategorySlug}"]`
          )
          .forEach((element) => {
            element.classList.add('is-active')
          })
      })
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-c-video-gallery]')
    .forEach(el => new CVideoGallery(el))
})
